<template>
    <div class="report-body panel panel-default">
      <div class="container panel-body">
        <div class="header">
            <div class="logo_header">
                 <img src="../assets/images/logo_header.png" class="logo-header_img" />
            </div>
            <div class="title_item">
                <div class="title_item_h">Maternal Blood Screening Report</div>
                <div class="title_item_z">母血篩選報告</div>
            </div>
        </div>
        <div class="report_content">
            <div class="report_tip" v-if="$i18n.locale=='en-US'">
                The following sample was received by First choice(Hong Kong) medical laboratory limited on 
                <span style="color:#fe0000;font-weight:bold;">{{reportData.ReceviedDate}}</span>
            </div>
             <div class="report_tip" v-else>
               香港卓信醫療化驗所於 &nbsp;
                <span style="color:#fe0000;font-weight:bold;">{{reportData.ReceviedDate}}</span>
                  &nbsp;收到如下樣本
            </div>
            <div class="text_name">
                <span v-if="$i18n.locale=='en-US'">Test Requester </span>
                <span v-else>受測者姓名 &nbsp;</span>
                <span style="color:#000;font-weight:bold;">{{reportData.TestRecipient}}</span>
            </div>
            <div class="id_no">
                 <span v-if="$i18n.locale=='en-US'"> ID Number  </span>
                <span v-else>證件號碼 &nbsp;</span>
               
                <span style="color:#000;font-weight:bold;">{{reportData.IDNo}}</span>
            </div>
            <div class="report_date">
                 
                <span v-if="$i18n.locale=='en-US'"> The test report has been issued on   </span>
                <span v-else>經檢驗，報告於 &nbsp;</span>
                <span style="color:#000000;font-weight:bold;">{{reportData.ReportDate}}</span>
                <span v-if="$i18n.locale!='en-US'"> &nbsp;發出！</span>
            </div>
            <div class="remark" v-if="$i18n.locale=='en-US'">
                If you have any queries,please feel free to contact us.
            </div>
            <div class="remark" v-else>
               如有任何疑問，歡迎緻電查詢！
            </div>
        </div>
        <div class="bottom_tip">
            <div class="item_tips">
                Tel <span v-if="$i18n.locale!='en-US'">電話</span>:(+852)2865-9399
            </div>
             <div class="item_tips">
                Fax <span v-if="$i18n.locale!='en-US'">傳真</span>:(+852)2865-966
            </div>
             <div class="item_tips">
                Website <span v-if="$i18n.locale!='en-US'">網址</span>:http://www.hkfirstchoice.com/
            </div>
             <div class="item_tips">
                Email <span v-if="$i18n.locale!='en-US'">電郵</span>:info@hkfirstchoice.com
            </div>
        </div>

        <div class="clear_d">
            <div class="clear_btn" v-if="$i18n.locale=='en-US'" @click="clearDateReport()">Clear</div>
            <div class="clear_btn" v-else @click="clearDateReport()">清除記錄</div>

        </div>
    </div>

    </div>
</template>
<script>
export default {
    data(){
        return{
            reportData:[],
        }
    },
    
    mounted(){
        this.reportData=JSON.parse(sessionStorage.getItem('ReportData'));
        console.log("reportData",this.reportData)
    },
    methods:{
       
       clearDateReport(){
           this.reportData=[]
            this.$store.commit('setReportData', this.reportData);
           this.$router.push({
                path:'/home'
            })
       },
    }
}
</script>

<style lang="scss" scoped>


.report-body{
    width:1200px;
    margin:auto;
    margin-top:12rem;
    margin-bottom:5rem;
    font-size:10px !important;
    border:1px solid #0099cc;
}

 .container {
        width: 100%;
        margin: 0 auto;
        padding: 24px 1rem 80px 1rem;
        box-sizing: border-box;
}

    .header {
        font-size:1.5rem;
        text-align: center;
        font-weight: bold;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .logo_header{
            .logo-header_img{
                height: 100%;
                width: 55%;
            }
            
        }
       .title_item{
            margin-left:20px;
            .title_item_h{
                font-size:28px;
                font-weight: bold;
                color:#000000;
            }
            .title_item_z{
                font-size:22px;
                color:#000;
            }
        }
    }

    .report_content{
        border:4px solid #0f4888;
        margin-top:25px;
        margin-right: 25px;
        margin-left:25px;
        padding-top:15px;
        padding-bottom: 15px;
       
        text-align: center;
        color:#333;
        font-size:18px;
        .report_tip{
           
        }
        .text_name{
            margin-top:5px;
        }
        .id_no{
            margin-top:5px;
        }
        .report_date{
            margin-top:5px;
        }
        .remark{
            margin-top:20px;
            color:#000;
            font-weight: bold;
            margin-bottom:10px;
        }
    }

    .bottom_tip{
        margin-top:15px;
        margin-right: 25px;
        margin-left:25px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .item_tips{
            font-size:16px;
        }
    }
    .clear_d{
        width: 100%;
        text-align: center;
        margin-top:60px;
        display: flex;
        justify-content: center;
        .clear_btn{
            border:1px solid #0f4888;
            background: #ddd;
            width: 100px;
            height:35px;
            font-size:17px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
    }
    
   
</style>


// WEBPACK FOOTER //
// src/view/reportoldresult.vue